import { Pipe, PipeTransform } from '@angular/core';
import { DateFilterService } from '../../services/filter/date-filter-service';

@Pipe({
  name: 'date',
  standalone: true,
})
export class DatePipe implements PipeTransform {
  private _dateFilterService: DateFilterService;

  public constructor(dateFilterService: DateFilterService) {
    this._dateFilterService = dateFilterService;
  }

  public transform(value: string | null | undefined | unknown): string {
    if (!value) {
      return '';
    } else if (typeof value === 'string')
      return this._dateFilterService.convertDate(value);
    else {
      throw new Error('DatePipe: Invalid value type');
    }
  }
}
